import { PROCESS, METRICS } from "../lib/constants";
import { SectionHeader } from "./Shared";

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 sm:py-32 bg-[#080808] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <SectionHeader
          eyebrow="Method · the protocol"
          title={
            <>
              Four steps.{" "}
              <span className="text-[#00E5FF] italic font-light">
                Zero shortcuts.
              </span>
            </>
          }
          sub="We treat every job like a controlled experiment. Documented inputs. Verified outputs."
        />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROCESS.map((p, i) => (
            <div
              key={p.step}
              data-testid={`process-step-${p.step}`}
              className="relative rounded-3xl border border-white/10 bg-black/50 p-7 hover:border-[#00E5FF]/40 transition-all duration-500 group"
            >
              <div className="flex items-baseline justify-between">
                <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/40">
                  Step {p.step}
                </span>
                <span className="font-display text-5xl font-thin text-white/10 group-hover:text-[#00E5FF]/30 transition-colors">
                  {p.step}
                </span>
              </div>
              <h3 className="mt-5 font-display text-2xl font-semibold tracking-tight">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-white/55 font-body leading-relaxed">
                {p.desc}
              </p>
              {i < PROCESS.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 h-px w-6 bg-gradient-to-r from-white/20 to-transparent" />
              )}
            </div>
          ))}
        </div>

        {/* Metrics Bar */}
        <div className="mt-20 rounded-3xl border border-white/10 bg-black/60 backdrop-blur overflow-hidden">
          <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-y md:divide-y-0 divide-white/10">
            {METRICS.map((m) => (
              <div
                key={m.label}
                data-testid={`metric-${m.label.replace(/\s+/g, "-").toLowerCase()}`}
                className="p-6 sm:p-8 text-center"
              >
                <div className="font-display text-4xl sm:text-5xl font-semibold text-[#00E5FF] tracking-tight">
                  {m.value}
                </div>
                <div className="mt-2 text-xs sm:text-sm font-body uppercase tracking-[0.18em] text-white/50">
                  {m.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
